import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import doubleArrow from "assets/icon/double-arrow-down.svg";

const PatientsDemographic = (props) => {
  const { fullName, dob, phone, firstName, lastName } = props;
  const [showPatientsDetails, setPatientsDetails] = useState(false);

  const togglePatientsDetails = () => {
    setPatientsDetails(!showPatientsDetails);
  };

  return (
    <div
      className="border p-8 mb-8"
      style={{ backgroundColor: "#DBCAD8", padding: "12px" }}
    >
      <Row>
        <Col md={9}>
          {!showPatientsDetails && (
            <Col sm={11} className="d-flex justify-content-between">
              <Row>
                <Col className="d-flex justify-content-left">
                  <div className="p16">
                    <span class="pdetails">Name:</span>
                    <span className="patient-details"> {fullName}</span>
                  </div>

                  <div className="p16">
                    <span className="pdetails purple-border-left ">DOB: </span>
                    <span className="patient-details"> {dob}</span>
                  </div>

                  {/* <div>
                <span className="pdetails purple-border-left ">Phone: </span>
                <span className="patient-details">{phone}</span>
              </div> */}
                  {/* <div className="allergies-status"> */}
                  <div className="p16">
                    <span className="allergies-title  purple-border-left">
                      Allergies:
                    </span>
                    <span className="allergies-name"> Penicillin, Sulfa</span>
                  </div>
                  {/* <div className="active-order">Active Orders: 01</div> */}
                  {/* </div> */}
                </Col>
              </Row>
              {/* <div>
                <span class="pdetails">Name:</span>
                <span className="patient-details"> {fullName}</span>
              </div>

              <div>
                <span className="pdetails purple-border-left ">DOB: </span>
                <span className="patient-details"> {dob}</span>
              </div>

              <div>
                <span className="pdetails purple-border-left ">Phone: </span>
                <span className="patient-details">{phone}</span>
              </div> */}
            </Col>
          )}
        </Col>
        <Col md={3} className="d-flex justify-content-end align-items-center">
          <div className="patient-demo" onClick={togglePatientsDetails}>
            Patient Demographics{" "}
            <span>
              {showPatientsDetails ? (
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform: "rotate(180deg)",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              ) : (
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{ transition: "opacity 0.3s ease" }}
                />
              )}
            </span>
          </div>
        </Col>
      </Row>
      {showPatientsDetails && (
        <div
          style={{
            borderTop: "1px solid #757575",
            padding: "8px",
            marginTop: "8px",
          }}
        >
          <Row>
            <Col md={3}>
              <div className="p16">
                <div class="pdetails">First Name</div>
                <div className="patient-details"> {firstName} </div>
              </div>
            </Col>
            <Col md={3}>
              {" "}
              <div className="p16">
                <div class="pdetails">Last Name</div>
                <div className="patient-details"> {lastName}</div>
              </div>
            </Col>
            <Col md={3}>
              {" "}
              <div className="p16">
                <div className="pdetails ">DOB</div>
                <div className="patient-details"> {dob} </div>
              </div>
            </Col>
            <Col md={3}>
              {" "}
              <div className="p16">
                <div className="pdetails">Phone Number</div>
                <div className="patient-details"> {phone}</div>
              </div>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={3}>
              <div className="p16">
                <div className="pdetails ">Address</div>
                <div className="patient-details">
                  123, Main ST Anytown, USA, 12345
                </div>
              </div>
            </Col>

            <Col md={3}>
              <div className="p16">
                <div className="allergies-title">Allergies</div>
                <div className="allergies-name"> Penicillin, Sulfa</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="p16">
                <div className="active-order">Active Orders</div>
                <div style={{ color: " #FF7C00", fontWeight: "600" }}>01</div>
              </div>
              <div></div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default PatientsDemographic;
